import Axios from 'axios';
import { protectedResources } from '../authConfig';
import { getPersonId } from './ApiGetPersonId';

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/AdvanceSalary/GetAdvanceSalaryRequest';
let tokenKey;

export async function getRequestDetail(year = 2022) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  // personId lets the API find the employee in Simond by ID instead of the slow email lookup.
  const personId = await getPersonId(sessionStorage.getItem('email') || '');
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
    params: personId ? { personId } : undefined,
  };

  const bodyParameters = {
    year: 2022,
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;

    const getData = JSON.parse(localStorage.getItem('obj_request_detail'));
    if (getData === null) {
      const response = await Axios.post(URL, bodyParameters, config);
      localStorage.setItem('obj_request_detail', JSON.stringify(response.data));
      return await response.data;
    } else {
      return await getData;
    }
  } catch (error) {
    if (error?.response?.status == 401) {
      localStorage.removeItem("obj_user_info");
      sessionStorage.removeItem("AccessToken");
      throw new Error("Unauthorized");
    }
    
    
    throw error;
  }
}
